import type { IRainFadeData } from './rain-fade.types'

export const RAIN_FADE_REGION_DATA: IRainFadeData[] = [
  {
    "region": "A",
    "rain": 0.1,
    "qos": 1
  },
  {
    "region": "A",
    "rain": 0.8,
    "qos": 0.3
  },
  {
    "region": "A",
    "rain": 2,
    "qos": 0.1
  },
  {
    "region": "A",
    "rain": 5,
    "qos": 0.03
  },
  {
    "region": "A",
    "rain": 8,
    "qos": 0.01
  },
  {
    "region": "A",
    "rain": 14,
    "qos": 0.003
  },
  {
    "region": "A",
    "rain": 22,
    "qos": 0.001
  },
  {
    "region": "B",
    "rain": 0.5,
    "qos": 1
  },
  {
    "region": "B",
    "rain": 2,
    "qos": 0.3
  },
  {
    "region": "B",
    "rain": 3,
    "qos": 0.1
  },
  {
    "region": "B",
    "rain": 6,
    "qos": 0.03
  },
  {
    "region": "B",
    "rain": 12,
    "qos": 0.01
  },
  {
    "region": "B",
    "rain": 21,
    "qos": 0.003
  },
  {
    "region": "B",
    "rain": 32,
    "qos": 0.001
  },
  {
    "region": "C",
    "rain": 0.7,
    "qos": 1
  },
  {
    "region": "C",
    "rain": 2.8,
    "qos": 0.3
  },
  {
    "region": "C",
    "rain": 5,
    "qos": 0.1
  },
  {
    "region": "C",
    "rain": 9,
    "qos": 0.03
  },
  {
    "region": "C",
    "rain": 15,
    "qos": 0.01
  },
  {
    "region": "C",
    "rain": 26,
    "qos": 0.003
  },
  {
    "region": "C",
    "rain": 42,
    "qos": 0.001
  },
  {
    "region": "D",
    "rain": 2.1,
    "qos": 1
  },
  {
    "region": "D",
    "rain": 4.5,
    "qos": 0.3
  },
  {
    "region": "D",
    "rain": 8,
    "qos": 0.1
  },
  {
    "region": "D",
    "rain": 13,
    "qos": 0.03
  },
  {
    "region": "D",
    "rain": 19,
    "qos": 0.01
  },
  {
    "region": "D",
    "rain": 29,
    "qos": 0.003
  },
  {
    "region": "D",
    "rain": 42,
    "qos": 0.001
  },
  {
    "region": "E",
    "rain": 0.6,
    "qos": 1
  },
  {
    "region": "E",
    "rain": 2.4,
    "qos": 0.3
  },
  {
    "region": "E",
    "rain": 6,
    "qos": 0.1
  },
  {
    "region": "E",
    "rain": 12,
    "qos": 0.03
  },
  {
    "region": "E",
    "rain": 22,
    "qos": 0.01
  },
  {
    "region": "E",
    "rain": 41,
    "qos": 0.003
  },
  {
    "region": "E",
    "rain": 70,
    "qos": 0.001
  },
  {
    "region": "F",
    "rain": 1.7,
    "qos": 1
  },
  {
    "region": "F",
    "rain": 4.5,
    "qos": 0.3
  },
  {
    "region": "F",
    "rain": 8,
    "qos": 0.1
  },
  {
    "region": "F",
    "rain": 15,
    "qos": 0.03
  },
  {
    "region": "F",
    "rain": 28,
    "qos": 0.01
  },
  {
    "region": "F",
    "rain": 54,
    "qos": 0.003
  },
  {
    "region": "F",
    "rain": 78,
    "qos": 0.001
  },
  {
    "region": "G",
    "rain": 3,
    "qos": 1
  },
  {
    "region": "G",
    "rain": 7,
    "qos": 0.3
  },
  {
    "region": "G",
    "rain": 12,
    "qos": 0.1
  },
  {
    "region": "G",
    "rain": 20,
    "qos": 0.03
  },
  {
    "region": "G",
    "rain": 30,
    "qos": 0.01
  },
  {
    "region": "G",
    "rain": 45,
    "qos": 0.003
  },
  {
    "region": "G",
    "rain": 65,
    "qos": 0.001
  },
  {
    "region": "H",
    "rain": 2,
    "qos": 1
  },
  {
    "region": "H",
    "rain": 4,
    "qos": 0.3
  },
  {
    "region": "H",
    "rain": 10,
    "qos": 0.1
  },
  {
    "region": "H",
    "rain": 18,
    "qos": 0.03
  },
  {
    "region": "H",
    "rain": 32,
    "qos": 0.01
  },
  {
    "region": "H",
    "rain": 55,
    "qos": 0.003
  },
  {
    "region": "H",
    "rain": 83,
    "qos": 0.001
  },
  {
    "region": "J",
    "rain": 8,
    "qos": 1
  },
  {
    "region": "J",
    "rain": 13,
    "qos": 0.3
  },
  {
    "region": "J",
    "rain": 20,
    "qos": 0.1
  },
  {
    "region": "J",
    "rain": 28,
    "qos": 0.03
  },
  {
    "region": "J",
    "rain": 35,
    "qos": 0.01
  },
  {
    "region": "J",
    "rain": 45,
    "qos": 0.003
  },
  {
    "region": "J",
    "rain": 55,
    "qos": 0.001
  },
  {
    "region": "K",
    "rain": 1.5,
    "qos": 1
  },
  {
    "region": "K",
    "rain": 4.2,
    "qos": 0.3
  },
  {
    "region": "K",
    "rain": 12,
    "qos": 0.1
  },
  {
    "region": "K",
    "rain": 23,
    "qos": 0.03
  },
  {
    "region": "K",
    "rain": 42,
    "qos": 0.01
  },
  {
    "region": "K",
    "rain": 70,
    "qos": 0.003
  },
  {
    "region": "K",
    "rain": 100,
    "qos": 0.001
  },
  {
    "region": "L",
    "rain": 2,
    "qos": 1
  },
  {
    "region": "L",
    "rain": 7,
    "qos": 0.3
  },
  {
    "region": "L",
    "rain": 15,
    "qos": 0.1
  },
  {
    "region": "L",
    "rain": 33,
    "qos": 0.03
  },
  {
    "region": "L",
    "rain": 60,
    "qos": 0.01
  },
  {
    "region": "L",
    "rain": 105,
    "qos": 0.003
  },
  {
    "region": "L",
    "rain": 150,
    "qos": 0.001
  },
  {
    "region": "M",
    "rain": 4,
    "qos": 1
  },
  {
    "region": "M",
    "rain": 11,
    "qos": 0.3
  },
  {
    "region": "M",
    "rain": 22,
    "qos": 0.1
  },
  {
    "region": "M",
    "rain": 40,
    "qos": 0.03
  },
  {
    "region": "M",
    "rain": 63,
    "qos": 0.01
  },
  {
    "region": "M",
    "rain": 95,
    "qos": 0.003
  },
  {
    "region": "M",
    "rain": 120,
    "qos": 0.001
  },
  {
    "region": "N",
    "rain": 5,
    "qos": 1
  },
  {
    "region": "N",
    "rain": 15,
    "qos": 0.3
  },
  {
    "region": "N",
    "rain": 35,
    "qos": 0.1
  },
  {
    "region": "N",
    "rain": 65,
    "qos": 0.03
  },
  {
    "region": "N",
    "rain": 95,
    "qos": 0.01
  },
  {
    "region": "N",
    "rain": 140,
    "qos": 0.003
  },
  {
    "region": "N",
    "rain": 180,
    "qos": 0.001
  },
  {
    "region": "P",
    "rain": 12,
    "qos": 1
  },
  {
    "region": "P",
    "rain": 34,
    "qos": 0.3
  },
  {
    "region": "P",
    "rain": 65,
    "qos": 0.1
  },
  {
    "region": "P",
    "rain": 105,
    "qos": 0.03
  },
  {
    "region": "P",
    "rain": 145,
    "qos": 0.01
  },
  {
    "region": "P",
    "rain": 200,
    "qos": 0.003
  },
  {
    "region": "P",
    "rain": 250,
    "qos": 0.001
  },
  {
    "region": "Q",
    "rain": 24,
    "qos": 1
  },
  {
    "region": "Q",
    "rain": 49,
    "qos": 0.3
  },
  {
    "region": "Q",
    "rain": 72,
    "qos": 0.1
  },
  {
    "region": "Q",
    "rain": 96,
    "qos": 0.03
  },
  {
    "region": "Q",
    "rain": 115,
    "qos": 0.01
  },
  {
    "region": "Q",
    "rain": 142,
    "qos": 0.003
  },
  {
    "region": "Q",
    "rain": 170,
    "qos": 0.001
  }
]
